import React, { useMemo } from 'react'

import clsx from 'clsx'

import { TableCell, Txt } from 'src/components/atoms'
import { DateTxt } from 'src/components/molecules'
import { LineLimitTxtWithTooltip } from 'src/components/molecules/texts/LineLimitTxtWithTooltip'

import { useGetExternalUsers } from 'src/hooks'
import { useGetCompassRoles } from 'src/hooks/useGetCompassRoles'
import { ProjectAssignUserEntity } from 'src/types'

type Props = {
  externalUser: ProjectAssignUserEntity
  className?: string
}

export function ExternalAssignUserTableRow({ externalUser, className }: Props) {
  const { compassRoles } = useGetCompassRoles()
  const { externalUsers } = useGetExternalUsers()

  const compassRole = useMemo(() => {
    return compassRoles.find(role => role.id === externalUser.compassRole.id)
  }, [externalUser, compassRoles])

  const targetUser = useMemo(() => {
    return externalUsers.find(user => user.id === externalUser.id)
  }, [externalUser.id, externalUsers])

  return (
    <div className={className}>
      <div className="tw-flex tw-gap-s0 tw-px-s0 tw-text-standardText-secondary tw-h-[4.3rem]">
        <TableCell className="tw-w-full tw-shrink">
          <LineLimitTxtWithTooltip
            className={clsx('tw-break-all tw-text-standardText-primary')}
            text={externalUser.name ?? '-'}
            lineLimit={2}
          />
        </TableCell>
        <TableCell width={20}>
          <LineLimitTxtWithTooltip
            className="tw-break-all"
            text={externalUser.email}
            lineLimit={2}
          />
        </TableCell>
        <TableCell width={20}>
          <LineLimitTxtWithTooltip
            className="tw-break-all"
            text={
              targetUser?.keywords && targetUser.keywords.length > 0
                ? targetUser.keywords.join(',')
                : '-'
            }
            lineLimit={2}
          />
        </TableCell>
        <TableCell width={20}>
          <DateTxt date={externalUser.assignedAt} />
        </TableCell>
        <TableCell width={20}>
          <Txt>{compassRole?.displayName}</Txt>
        </TableCell>
      </div>
    </div>
  )
}
